(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["custom-featured-product"] && !Shopify.designMode) return;
  try {
    class CustomFeaturedProduct extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();

      // Literal event name: this bundle is not a module, so ThemeEvents cannot be imported here.
      this.addEventListener('variant:update', this.handleVariantUpdate, { signal: this.abortController.signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    // The event's rendered fragment is the product's own page, not this one, so the srcset is rebuilt here rather than lifted from it.
    handleVariantUpdate = (event) => {
      const image = this.querySelector('.custom-featured-product__image');
      const source = event.detail?.resource?.featured_media?.preview_image?.src;

      if (!image || !source) return;

      const widths = (this.dataset.imageWidths || '')
        .split(',')
        .map((width) => parseInt(width, 10))
        .filter((width) => width > 0);

      const urlAtWidth = (width) => {
        const url = new URL(source, window.location.origin);
        url.searchParams.set('width', String(width));
        return url.href;
      };

      if (widths.length === 0) {
        image.removeAttribute('srcset');
        image.src = source;
        return;
      }

      image.srcset = widths.map((width) => `${urlAtWidth(width)} ${width}w`).join(', ');
      image.src = urlAtWidth(widths[widths.length - 1]);
    };
  }

  if (!customElements.get('custom-featured-product')) {
    customElements.define('custom-featured-product', CustomFeaturedProduct);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["custom-pdp-confidence-callouts"] && !Shopify.designMode) return;
  try {
    (function () {
    let activeEl = null;
    let startX = 0;
    let startScrollLeft = 0;
    let lastPageX = 0;
    let didDrag = false;
    let lastDraggedEl = null;
    let rafId = null;
  
    const DRAG_THRESHOLD = 5;
    const SELECTOR = '.pdp-confidence-callouts__inner';
  
    function applyScroll() {
      rafId = null;
      if (activeEl) {
        activeEl.scrollLeft = startScrollLeft - (lastPageX - startX);
      }
    }
  
    function onPointerDown(e) {
      if (e.button !== 0) return;
  
      const inner = e.target.closest(SELECTOR);
      if (!inner) return;
  
      activeEl = inner;
      startX = lastPageX = e.pageX;
      startScrollLeft = inner.scrollLeft;
      didDrag = false;
  
      inner.classList.add('is-dragging');
      inner.setPointerCapture(e.pointerId);
    }
  
    function onPointerMove(e) {
      if (!activeEl) return;
  
      lastPageX = e.pageX;
  
      if (!didDrag && Math.abs(lastPageX - startX) > DRAG_THRESHOLD) {
        didDrag = true;
      }
  
      if (rafId === null) {
        rafId = requestAnimationFrame(applyScroll);
      }
    }
  
    function endDrag(e) {
      if (!activeEl) return;
  
      if (rafId !== null) {
        cancelAnimationFrame(rafId);
        rafId = null;
      }
  
      activeEl.releasePointerCapture(e.pointerId);
  
      if (didDrag) {
        lastDraggedEl = activeEl;
        document.addEventListener('click', preventClickOnce, true);
      }
  
      activeEl.classList.remove('is-dragging');
      activeEl = null;
    }
  
    function preventClickOnce(ev) {
      document.removeEventListener('click', preventClickOnce, true);
  
      if (lastDraggedEl && lastDraggedEl.contains(ev.target)) {
        ev.preventDefault();
        ev.stopPropagation();
      }
  
      lastDraggedEl = null;
    }
  
    document.addEventListener('pointerdown', onPointerDown);
    document.addEventListener('pointermove', onPointerMove);
    document.addEventListener('pointerup', endDrag);
    document.addEventListener('pointercancel', endDrag);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["custom-send-a-hint"] && !Shopify.designMode) return;
  try {
    class CustomSendAHint extends HTMLElement {
    connectedCallback() {
      this.updateShareLinks();
      this.trackHintVisit();
      this.addEventListener('click', this.handleHintClick);
    }

    /**
     * Composes each button's href from its own tagged URL plus the variant selected right now,
     * so the recipient lands on the variant that was hinted at rather than the product's
     * default. Re-run on click: the picker morphs only itself, so a variant chosen after this
     * block rendered is only visible at click time.
     *
     * The server already substituted [product_url] with the untagged link, so occurrences in
     * the copy are expanded rather than left alongside a second, differing URL.
     */
    updateShareLinks() {
      const appendUrl = this.hasAttribute('data-hint-append-url');
      const variantId = this.currentVariant().id;

      this.querySelectorAll('[data-hint-link]').forEach((link) => {
        const baseUrl = link.dataset.hintShareUrl || '';
        const shareUrl = baseUrl && variantId ? `${baseUrl}&variant=${variantId}` : baseUrl;
        const withVariant = (text) => (baseUrl ? text.split(baseUrl).join(shareUrl) : text);

        let body = withVariant(link.dataset.hintBody || '');

        if (appendUrl && shareUrl && !body.includes(shareUrl)) {
          body += `\n\n${shareUrl}`;
        }

        // Outlook desktop wants CRLF in a mailto body; other clients accept it.
        const encodedBody = encodeURIComponent(body.replace(/\r?\n/g, '\r\n'));

        if (link.dataset.hintLink === 'email') {
          const subject = encodeURIComponent(withVariant(link.dataset.hintSubject || ''));
          link.href = `mailto:?subject=${subject}&body=${encodedBody}`;
        } else {
          link.href = `https://wa.me/?text=${encodedBody}`;
        }
      });
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleHintClick);
    }

    handleHintClick = (event) => {
      const target = event.target instanceof Element ? event.target : null;
      const link = target?.closest('[data-hint-link]');

      if (!link) return;

      // Bubbles to here before the default action reads href, so this is the last chance to
      // pick up a variant change made since load.
      this.updateShareLinks();
      this.trackHint(link.dataset.hintLink === 'whatsapp' ? 'whatsapp' : 'email');
    };

    /**
     * Elevar processes only what is pushed to its own array — a push to window.dataLayer is
     * ignored (docs.getelevar.com/docs/headless-implementing-the-data-layer). The array is
     * created here rather than assumed, so a click landing before the Elevar app embed has
     * loaded is buffered and replayed once it does.
     *
     * dl_drop_a_hint is a custom event: it has to be registered under Custom Events in the
     * Elevar dashboard before it reaches any destination. The payload is the SKU of the
     * selected variant and the channel it was sent through, and nothing else.
     *
     * @param {'email' | 'whatsapp'} method
     */
    trackHint(method) {
      window.ElevarDataLayer = window.ElevarDataLayer ?? [];

      window.ElevarDataLayer.push({
        event: this.dataset.hintEvent || 'dl_drop_a_hint',
        event_properties: {
          method,
          sku: this.currentVariant().sku || '',
        },
      });
    }

    /**
     * Counts a recipient arriving on a tagged hint link. sessionStorage stops a reload — or a
     * second copy of this block on the page — from counting twice; the param is deliberately
     * left in the URL so anything else reading it still can.
     *
     * The link carries ?variant=, so the SKU here is the one that was actually hinted at and
     * pairs with the SKU on the dl_drop_a_hint click that produced it.
     */
    trackHintVisit() {
      const method = new URLSearchParams(window.location.search).get('hint');

      if (method !== 'email' && method !== 'whatsapp') return;

      const seenKey = `dl_drop_a_hint_visit:${method}:${window.location.pathname}`;

      try {
        if (sessionStorage.getItem(seenKey)) return;
        sessionStorage.setItem(seenKey, '1');
      } catch {
        // Storage blocked (private mode, cookie settings). Counting twice beats not counting.
      }

      window.ElevarDataLayer = window.ElevarDataLayer ?? [];

      window.ElevarDataLayer.push({
        event: this.dataset.hintVisitEvent || 'dl_drop_a_hint_visit',
        event_properties: {
          method,
          sku: this.currentVariant().sku || '',
        },
      });
    }

    currentVariant() {
      const selectedId = this.selectedVariantId();
      const variants = this.hintVariants();

      return (
        variants.find((variant) => String(variant.id) === selectedId) ||
        variants[0] || { id: this.dataset.hintVariantId }
      );
    }

    /**
     * The picker morphs only itself on a variant change, so the id rendered into this block
     * can be stale by click time. The product form's hidden input is the live value.
     */
    selectedVariantId() {
      const productId = this.dataset.hintProductId || '';
      const form = document.querySelector(`product-form-component[data-product-id="${productId}"]`);
      const input = form?.querySelector('[name="id"]');

      return String(input?.value || this.dataset.hintVariantId || '');
    }

    hintVariants() {
      if (!this.variantCache) {
        const source = this.querySelector('[data-hint-variants]');

        try {
          this.variantCache = source ? JSON.parse(source.textContent) : [];
        } catch {
          this.variantCache = [];
        }
      }

      return this.variantCache;
    }
  }

  if (!customElements.get('custom-send-a-hint')) {
    customElements.define('custom-send-a-hint', CustomSendAHint);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["offer-info-overlay"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.offer-info-overlay-container').forEach(container => {
      const trigger = container.querySelector('[data-info-trigger]');
      const overlay = container.querySelector('[data-info-overlay]');
      const iconContent = trigger?.querySelector('[data-icon-content]');
      
      if (!trigger || !overlay) return;
      
      // Find parent offer container
      let parentGroup = container.parentElement;
      while (parentGroup && !parentGroup.hasAttribute('data-shopify-editor-block')) {
        parentGroup = parentGroup.parentElement;
      }
      
      const updatePosition = () => {
        if (!parentGroup || overlay.hasAttribute('hidden')) return;
        const { top, left, width, height } = parentGroup.getBoundingClientRect();
        Object.assign(overlay.style, { 
          top: `${top}px`, 
          left: `${left}px`, 
          width: `${width}px`, 
          height: `${height}px` 
        });
      };
      
      trigger.addEventListener('click', () => {
        const isHidden = overlay.hasAttribute('hidden');
        
        if (parentGroup) {
          const { top, left, width, height } = parentGroup.getBoundingClientRect();
          Object.assign(overlay.style, { 
            top: `${top}px`, 
            left: `${left}px`, 
            width: `${width}px`, 
            height: `${height}px` 
          });
        }
        
        overlay.toggleAttribute('hidden', !isHidden);
        if (iconContent) iconContent.textContent = isHidden ? '×' : 'i';
        trigger.setAttribute('aria-label', isHidden ? 'Close information' : 'Show more information');
      });
      
      window.addEventListener('scroll', updatePosition, { passive: true });
      window.addEventListener('resize', updatePosition, { passive: true });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
